import { baseUrl } from '../network'  

export const resetPasswordUrl = baseUrl + 'api/user/password/reset'
export const verifyResetPasswordUrl = baseUrl + 'api/user/password/reset/confirm'